import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ManageDrivers from "../pages/ManageDrivers";
import ManageOutlets from "../pages/ManageOutlets";
import ManageDriverDetail from "../pages/ManageDriverDetail";
import ManageOutletDetail from "../pages/ManageOutletDetail";
import Drivers from "../pages/Drivers";
import DriverDetail from "../pages/DriverDetail";
import DriversHistory from "../pages/DriversHistory";
import DriversWeeklyEarnings from "../pages/DriversWeeklyEarnings";
import OrderDetails from "../pages/OrderDetails";
import OutletsHistory from "../pages/OutletsHistory";
import Outlets from "../pages/Outlets";
import OutletDetail from "../pages/OutletDetail";
import Orders from "../pages/Orders";
import Pricing from "../pages/Pricing";
import ManageAdmin from "../pages/ManageAdmin";
import AddAdmin from "../pages/AddAdmin";
import HomePage from "../pages/Homepage";
import OutletWeeklyEarnings from "../pages/OutletsWeeklyEarnings";
import ProtectedRoute from "../components/ProtectedRoute";
import NetworkStatus from "../pages/NetworkStatus";
import { useEffect, useState } from "react";
import Profile from "../pages/Profile";
import ActiveHubs from "../pages/ActiveHubs";
import AllocateNewDriver from "../pages/AllocateNewDriver";
import { APIProvider } from "@vis.gl/react-google-maps";
import PageNotFound from "../pages/PageNotFound";
import NotificationBell from "../components/NotificationBell";
import { fetchNotificationsApi } from "../api/services/notificationService";
import { NotificationAlertProvider } from "./NotificationAlertContext";
import Notifications from "../pages/Notifications";

function App() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const updateNetworkStatus = () => {
      setIsOffline(!navigator.onLine);
    };

    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, []);

  return (
    <>
      {isOffline ? (
        <NetworkStatus />
      ) : (
          <APIProvider apiKey={process.env.REACT_APP_MAP_API_KEY}>
                    <NotificationAlertProvider>

            <Router>
              <Routes>
                {/* Auth and Homepage */}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <HomePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/active-hubs"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ActiveHubs />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />

                {/* Driver and Outlet Onboarding */}
                <Route
                  path="/manage-drivers"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ManageDrivers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/manage-drivers/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ManageDriverDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/manage-outlets"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ManageOutlets />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/manage-outlets/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ManageOutletDetail />
                    </ProtectedRoute>
                  }
                />

                {/* Driver Profile */}
                <Route
                  path="/drivers"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Drivers />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/drivers/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <DriverDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/history/drivers/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <DriversHistory />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/drivers/weekly-earnings/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <DriversWeeklyEarnings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/allocate-new-driver/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <AllocateNewDriver />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <OrderDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Orders />
                    </ProtectedRoute>
                  }
                />

                {/* Outlet Profile */}
                <Route
                  path="/history/outlets/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <OutletsHistory />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/outlets"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Outlets />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/outlets/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <OutletDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/outlets/weekly-earnings/:id"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <OutletWeeklyEarnings />
                    </ProtectedRoute>
                  }
                />

                {/* Pricing */}
                <Route
                  path="/pricing"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Pricing />
                    </ProtectedRoute>
                  }
                />

                {/* Manage Admin */}
                <Route
                  path="/manage-admin"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <ManageAdmin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/add-admin"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <AddAdmin />
                    </ProtectedRoute>
                  }
                />

                {/* Profile */}
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Profile />
                    </ProtectedRoute>
                  }
                />

                {/* Notifications */}
                <Route
                  path="/notifications"
                  element={
                    <ProtectedRoute>
                      <NotificationBell fetchNotificationsApi={fetchNotificationsApi} />
                      <Notifications />
                    </ProtectedRoute>
                  }
                />

                {/* Not found */}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Router>
            </NotificationAlertProvider>

          </APIProvider>
      )}
    </>
  );
}

export default App;
